import { Component, ElementRef } from "@angular/core";
import { Observable } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import { DevelopmentsService } from "../../../../services/developments.services";
import { CropperrComponent } from "../../../../create-edit/multimedia/cropperr/cropperr.component";

/**
 * Cropper dos empreendimentos: o mesmo componente dos imóveis (template e
 * lógica partilhados), a carregar imagens pelo `DevelopmentsService` e a
 * emitir `crop-image-dev`.
 */
@Component({
  selector: "app-cropperr-developments",
  templateUrl: "../../../../create-edit/multimedia/cropperr/cropperr.component.html",
  styleUrls: ["../../../../create-edit/multimedia/cropperr/cropperr.component.scss"],
})
export class CropperrDevelopmentsComponent extends CropperrComponent {
  protected override cropEventName = "crop-image-dev";

  constructor(
    eventService: EventService,
    private developmentsService: DevelopmentsService,
    host: ElementRef<HTMLElement>,
  ) {
    super(eventService, null as any, host);
  }

  protected override loadMasterImage(fileName: string): Observable<Blob> {
    return this.developmentsService.getMasterImage(fileName);
  }

  protected override loadPublishedImage(url: string): Observable<Blob> {
    return this.developmentsService.getImage(url);
  }
}
